import { createStore } from "@tanstack/store"
import { registerSessionCleanup } from "@/shared/lib/auth"
import type { RegistrationFormValues } from "../form-validation"

type OnboardingState = {
	formValues: Partial<RegistrationFormValues> | null
}

const STORAGE_KEY = "onboarding-form"

function hydrateState(): OnboardingState {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY)
		if (raw) return { formValues: JSON.parse(raw) }
	} catch {}
	return { formValues: null }
}

export const onboardingStore = createStore(hydrateState())

function resetOnboarding(): void {
	onboardingStore.setState(() => ({ formValues: null }))
	sessionStorage.removeItem(STORAGE_KEY)
}

onboardingStore.subscribe(() => {
	const { formValues } = onboardingStore.state
	if (formValues) {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(formValues))
	} else {
		sessionStorage.removeItem(STORAGE_KEY)
	}
})

export function updateFormValues(
	partial: Partial<RegistrationFormValues>,
): void {
	onboardingStore.setState((s) => ({
		...s,
		formValues: { ...s.formValues, ...partial },
	}))
}

export function getOnboardingFormValues(): Partial<RegistrationFormValues> | null {
	return onboardingStore.state.formValues
}

registerSessionCleanup(resetOnboarding)
